// src/firebase.js
import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase configuration for your project (gator-7bf72)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: 'gator-7bf72.firebaseapp.com',
  projectId: 'gator-7bf72',
  // Use the bucket name (), not the appspot.com domain
  storageBucket: 'gator-7bf72.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
  measurementId: process.env.REACT_APP_measurementId,
};

// Initialize Firebase app
export const app = initializeApp(firebaseConfig);

// Firestore: force a transport that works behind strict networks/proxies
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
  // If issues persist, switch to: experimentalForceLongPolling: true,
  useFetchStreams: false,
});

// Initialize Firebase services
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

// Create a promise that resolves when the auth state is ready
export const authPromise = new Promise((resolve, reject) => {
  const unsubscribe = auth.onAuthStateChanged(
    (user) => {
      unsubscribe();
      resolve(user);
    },
    (error) => {
      unsubscribe();
      reject(error);
    }
  );
});
